import PropTypes from 'prop-types'
import React from 'react'
import styles from './RadioButtonButton.module.css'

const RadioButtonButton = React.forwardRef((props, ref) => {
  const { name, checked, value, onChange, disabled, children } = props

  const clases = [
    `btn ${styles.btnPublicarEstadoProducto}`,
    checked && 'clicked',
    disabled && 'disabled'
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={clases}>
      <input
        type="radio"
        ref={ref}
        name={name}
        checked={checked}
        value={value}
        onChange={onChange}
        disabled={disabled}
        aria-disabled={disabled}
      />
      {children}
    </label>
  )
})

RadioButtonButton.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node
}

RadioButtonButton.displayName = 'RadioButtonButton'

export default RadioButtonButton
